exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media(max-width: 1196px){#applications-container{padding:0 3em}}@media(max-width: 959px){#applications-container{padding:0 2em}}@media(max-width: 480px){#applications-container .burners .item .title p{line-height:1.5em}#applications-container .title-heading{font-size:3em}#applications-container .row.section{margin-left:-2em;margin-right:-2em}}", ""]);

// exports
